<div [class.content-body]="!propertyId">
    <app-breadcrumb *ngIf="!propertyId" [breadcrumb]="breadcrumbList"></app-breadcrumb>
    <div [class.container-fluid]="!propertyId">
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center" *ngIf="!propertyId && checkEnquiryAdd">
                <h4 class="card-title mb-0">Enquiries</h4>
                <button
                    class="btn btn-primary btn-sm"
                    (click)="openAddEnquiryModal()"
                    [disabled]="loadingService.isLoading()">
                    <i class="bi bi-plus-circle me-1"></i> Add Enquiry
                </button>
            </div>
            <div class="card-body p-0">
                <!-- Filters: Search, Platform, Property & Status -->
                <div class="row px-3 py-2 align-items-end">
                  <div class="col-md-2">
                    <label class="form-label">Search</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Search enquiries"
                      [(ngModel)]="filterSearch"
                      (blur)="onFilterChange()"
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="form-label">Platform</label>
                    <ng-select
                      ngDefaultControl
                      [items]="platformItems"
                      placeholder="Select Platform"
                      class="select2 select2-sm"
                      [(ngModel)]="filterPlatform"
                      (open)="filterPlatform===null && (filterPlatform='')"
                      (change)="onFilterChange()"
                    ></ng-select>
                  </div>
                  <div class="col-md-2" *ngIf="!propertyId">
                    <label class="form-label">Property</label>
                    <ng-select
                      ngDefaultControl
                      [items]="propertiesItems"
                      placeholder="Select Property"
                      class="select2 select2-sm"
                      [typeahead]="searchProperty$"
                      [virtualScroll]="true"
                      [(ngModel)]="filterProperty"
                      (scrollToEnd)="onPropertyScrollEnd()"
                      (change)="onFilterChange()"
                    >
                      <ng-template #template let-data="data">{{ data.label }}</ng-template>
                    </ng-select>
                  </div>
                  <div class="col-md-2">
                    <label class="form-label">Status</label>
                    <ng-select
                      ngDefaultControl
                      [items]="statusOptions"
                      bindValue="value"
                      bindLabel="label"
                      placeholder="Select Status"
                      class="select2 select2-sm"
                      [(ngModel)]="filterStatus"
                      (change)="onFilterChange()"
                    ></ng-select>
                  </div>

                  <div class="col-md-1">
                    <button
                      class="btn btn-danger btn-sm"
                      type="button"
                      (click)="clearFilters()"
                    >
                      Clear
                    </button>
                  </div>
                </div>
                <div class="row">
                    <div class="col-xl-12">
                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
                            <table id="enquiries-tbl" class="table mb-0" matSort (matSortChange)="sortData($event)">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th *ngIf="!hidePropertyColumn">Property</th>
                                        <th mat-sort-header="platform">Platform</th>
                                         <th mat-sort-header="name">Name</th>
                                         <th mat-sort-header="phone">Phone</th>
                                        <th>Property Type</th>
                                        <th mat-sort-header="status">Status</th>
                                        <th mat-sort-header="follow_up_date">Follow Up Date</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of allData.data; track item.id){
                                    <tr>
                                        <td>{{ item.created_at | date:'dd-MM-yyyy' }}</td>
                                        <td *ngIf="!hidePropertyColumn">
                                            <span *ngIf="item.property?.id" class="text-primary c-pointer" [routerLink]="['/admin/properties/property-view', item.property.id, 8]">
                                                {{ item.property?.name }}
                                            </span>
                                            <span *ngIf="!item.property?.id">-</span>
                                        </td>
                                        <td>{{ item.platform }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.phone }}</td>
                                        <td>{{ item.property_type || '-' }}</td>
                                        <td>
                                            <span *ngIf="item.status" class="badge"
                                                  [class.badge-success]="item.status == 'Converted'"
                                                  [class.badge-primary]="item.status == 'Hot'"
                                                  [class.badge-warning]="item.status == 'Warm'"
                                                  [class.badge-light]="item.status == 'Cold'"
                                                  [class.badge-secondary]="item.status == 'Reject'">
                                                {{ item.status }}
                                            </span>
                                            <span *ngIf="!item.status">-</span>
                                        </td>
                                        <td>{{ item.follow_up_date ? (item.follow_up_date | date:'dd-MM-yyyy') : '-' }}</td>
                                        <td class="text-center">
                                            <div class="img-wrapper" *ngIf="checkEnquiryUpdate">
                                                <button type="button" class="btn btn-primary shadow btn-xs sharp mb-1 me-2" (click)="openUpdateModal(item)">
                                                    <i class="fa fa-refresh"></i>
                                                </button>
                                                <div class="tooltip-text">Update Status</div>
                                            </div>
                                            <div class="img-wrapper" *ngIf="canEditEnquiry(item)">
                                                <button type="button" class="btn btn-warning shadow btn-xs sharp mb-1 me-2" (click)="editEnquiry(item.id)">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                                <div class="tooltip-text">Edit</div>
                                            </div>
                                            <div class="img-wrapper">
                                                <button type="button" class="btn btn-info shadow btn-xs sharp mb-1 me-2" (click)="viewEnquiry(item.id)">
                                                    <i class="fa fa-eye"></i>
                                                </button>
                                                <div class="tooltip-text">View</div>
                                            </div>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
							<div class="dataTables_info" id="enquiries_info" role="status" aria-live="polite">
                                Showing {{allData.startPage}} to {{allData.endPage}} of {{ totalPage }} entries
                            </div>
                            <div class="dataTables_paginate paging_simple_numbers pt-2">
                                <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Update Enquiry Modal -->
    <div class="modal fade" #updateModal tabindex="-1" aria-labelledby="updateModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="updateModalLabel">Update Enquiry</h5>
                    <button type="button" class="btn-close" (click)="closeUpdateModal()" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form [formGroup]="updateForm">
                        <!-- Follow Up Date -->
                        <div class="mb-3">
                            <label class="form-label">Follow Up Date</label>
                            <input
                                type="date"
                                class="form-control"
                                formControlName="follow_up_date"
                            />
                        </div>

                        <!-- Status -->
                        <div class="mb-3">
                            <label class="form-label">Status</label>
                            <ng-select
                                ngDefaultControl
                                [items]="statusOptions"
                                bindValue="value"
                                bindLabel="label"
                                placeholder="Select Status"
                                class="select2"
                                formControlName="status"
                                [clearable]="true"
                            ></ng-select>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeUpdateModal()">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="submitUpdate()">Update</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Add Enquiry Modal -->
    <div #addEnquiryModal
         class="offcanvas offcanvas-end customeoff {{ showAddModal ? 'show':''}}"
         tabindex="-1"
         id="addEnquiryModal"
         data-bs-backdrop="static">

        <!-- Header -->
        <div class="offcanvas-header">
            <h5 class="modal-title">Add Enquiry</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="closeAddEnquiryModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <!-- Body Content -->
        <div class="offcanvas-body">
            <div class="container-fluid">
                <form [formGroup]="addEnquiryForm" (ngSubmit)="submitAddEnquiry()" autocomplete="off">
                    <div class="row">
                        <!-- Property (Dropdown) -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Property <span class="text-danger">*</span></label>
                            <ng-select
                                ngDefaultControl
                                [items]="addFormPropertiesItems"
                                bindValue="value"
                                bindLabel="label"
                                placeholder="Select Property"
                                class="select2"
                                formControlName="property_id"
                                [typeahead]="searchAddFormProperty$"
                                [virtualScroll]="true"
                                (scrollToEnd)="onAddFormPropertyScrollEnd()"
                                [class.is-invalid]="isAddFieldInvalid('property_id')"
                            >
                                <ng-template #template let-data="data">{{ data.label }}</ng-template>
                            </ng-select>
                            <div class="invalid-feedback" *ngIf="isAddFieldInvalid('property_id')">
                                Property is required
                            </div>
                        </div>

                        <!-- Property Type -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Property Type</label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="property_type"
                                placeholder="Enter property type" />
                        </div>

                        <!-- Name -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Name <span class="text-danger">*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="name"
                                placeholder="Enter name"
                                [class.is-invalid]="isAddFieldInvalid('name')" />
                            <div class="invalid-feedback" *ngIf="isAddFieldInvalid('name')">
                                Name is required
                            </div>
                        </div>

                        <!-- Name -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Phone <span class="text-danger">*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="phone"
                                placeholder="Enter phone"
                                [class.is-invalid]="isAddFieldInvalid('phone')" />
                            <div class="invalid-feedback" *ngIf="isAddFieldInvalid('phone')">
                                Phone is required
                            </div>
                        </div>

                        <!-- Email -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Email</label>
                            <input
                                type="email"
                                class="form-control"
                                formControlName="email"
                                placeholder="Enter email"
                                [class.is-invalid]="isAddFieldInvalid('email')" />
                            <div class="invalid-feedback" *ngIf="isAddFieldInvalid('email')">
                                Invalid email format
                            </div>
                        </div>

                        <!-- Locality -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Locality</label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="locality"
                                placeholder="Enter locality" />
                        </div>

                        <!-- City -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">City</label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="city"
                                placeholder="Enter city" />
                        </div>

                        <!-- State -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">State</label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="state"
                                placeholder="Enter state" />
                        </div>

                        <!-- Amount -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Amount</label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="amount"
                                placeholder="Enter amount" />
                        </div>

                        <!-- Bed Rooms -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Bed Rooms</label>
                            <input
                                type="text"
                                class="form-control"
                                formControlName="bath_room"
                                placeholder="Enter required bed rooms" />
                        </div>

                        <!-- Looking For -->
                        <div class="col-12 mb-3">
                            <label class="form-label">Looking For</label>
                            <textarea
                                class="form-control"
                                formControlName="looking_for"
                                rows="3"
                                placeholder="Enter what the customer is looking for"></textarea>
                        </div>

                        <!-- Status -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Status</label>
                            <select
                                class="form-select"
                                formControlName="status">
                                <option *ngFor="let option of statusOptions" [value]="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                        </div>

                        <!-- Follow Up Date -->
                        <div class="col-xl-6 mb-3">
                            <label class="form-label">Follow Up Date</label>
                            <input
                                type="date"
                                class="form-control"
                                formControlName="follow_up_date" />
                        </div>
                    </div>

                    <!-- Form Actions -->
                    <div>
                        <button class="btn btn-primary ms-1 me-3" type="submit"
                                [disabled]="addEnquiryForm.invalid || loadingService.isLoading()">
                            Add Enquiry
                        </button>
                        <button class="btn btn-danger light me-1" type="button" (click)="closeAddEnquiryModal()">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Backdrop for Add Modal -->
    @if(showAddModal){
        <div class="offcanvas-backdrop fade show" (click)="closeAddEnquiryModal()"></div>
    }
</div>
